import React, { Component } from 'react'
import { connect } from 'react-redux'
import uuid from 'uuid/v4'
import { Menu } from 'config'
import MenuItem from './menu/Item'

class Sidebar extends Component {
  componentWillReceiveProps (nextProps) {
    if (this.props.updated === nextProps.updated) return
    this.forceUpdate()
  }
  render () {
    return (
      <aside className='sidebar'>
        {Object.values(Menu.items).map((item) => {
          return (
            <MenuItem
              key={uuid()}
              icon={item.icon}
              title={item.title}
              children={item.children} />)
        })}
      </aside>
    )
  }
}
// eslint-disable-next-line
Sidebar = connect(state => state.siteReducer)(Sidebar)
export default Sidebar



// WEBPACK FOOTER //
// ./src/components/core/Sidebar.js